import { TooltipLabel } from "../common/Tooltip";

export function BottomStatusBar({ reviewNotes }: { reviewNotes: string[] }) {
  const label = reviewNotes.length === 1 ? "Review note" : "Review notes";
  return (
    <div className="bottom-status-bar">
      <div className="status-pill status-warn">
        <TooltipLabel tooltip="Review notes appear here only after writing activity is recorded in the editor.">
          <span id="review-notes-label">{label}</span>
        </TooltipLabel>
        <ul
          className="review-note-list"
          role="list"
          aria-live="polite"
          aria-labelledby="review-notes-label"
        >
          {reviewNotes.map((note) => (
            <li key={note}>{note}</li>
          ))}
        </ul>
      </div>
    </div>
  );
}
